import { parseImage } from "./image";
import { parseFiles } from "./file";
import { parseApplication } from "./application";
import { CONTENT_TYPE_APPLICATION } from "../organizationRoles";

export const parseOrganizations = (data) => {
  if (!data) return [];

  // Handle plain object
  if (typeof data === "object" && !Array.isArray(data)) {
    return Object.values(data).map((datum) => parseOrganization(datum));
  }

  // Handle plain array
  if (Array.isArray(data)) {
    return data.map((datum) => parseOrganization(datum));
  }

  return [];
};

export const parseOrganization = (datum) => {
  if (!datum) return;

  return {
    id: datum.id,
    uid: datum.uid,
    uuid: datum.uuid,
    title: datum.title,
    description: datum.description,
    content: parseOrganizationContents(datum.content),
    created: datum.created,
    image: parseImage(datum.image),
    documents: parseFiles(datum.documents),
    members: parseOrganizationMembers(datum.members),
  };
};

export const parseOrganizationMembers = (data) => {
  if (!data) return [];

  // Handle plain object/array
  const dataArray = Array.isArray(data) ? data : Object.values(data || {});
  return dataArray.map((datum) => parseOrganizationMember(datum));
};

export const parseOrganizationMember = (datum) => {
  if (!datum) return;

  // Handle roles
  let roles = [];
  const rolesData = datum.roles;
  if (rolesData) {
    if (Array.isArray(rolesData)) {
      roles = rolesData;
    } else if (typeof rolesData === "object") {
      roles = Object.values(rolesData);
    }
  }

  return {
    uuid: datum.uuid,
    membershipUuid: datum.membershipUuid,
    id: datum.id,
    userName: datum.userName,
    created: datum.created,
    changed: datum.changed,
    resentInvitation: datum.resentInvitation,
    status: datum.status,
    roles,
  };
};

export const parseOrganizationRoles = (data) => {
  if (!data) return [];

  // Handle plain object/array
  const dataArray = Array.isArray(data) ? data : Object.values(data || {});
  return dataArray.map((datum) => parseOrganizationRole(datum));
};

export const parseOrganizationRole = (datum) => {
  if (!datum) return;

  // Handle permissions
  let permissions = [];
  const permissionsData = datum.permissions;
  if (permissionsData) {
    if (Array.isArray(permissionsData)) {
      permissions = permissionsData;
    } else if (typeof permissionsData === "object") {
      permissions = Object.values(permissionsData);
    }
  }

  return {
    uuid: datum.uuid,
    id: datum.id,
    permissions,
  };
};

export const parseFileUploadErrors = (data) => {
  if (!data) return [];

  // Handle plain object/array
  const dataArray = Array.isArray(data) ? data : Object.values(data || {});
  return dataArray.map((datum) => ({
    title: datum.title,
    detail: datum.detail,
    fileName: datum.fileName,
    uuid: datum.uuid,
    created: datum.created,
  }));
};

export const parseMessages = (
  messages,
  type,
  messageType,
  containsType = true
) => {
  const data = messages?.[type];

  if (!data) return [];

  let result = [];

  // Handle plain object - convert to array
  if (typeof data === "object") {
    result = Object.values(data).map((datum) => ({
      uuid: datum.uuid,
      created: datum.created,
      description: datum.description,
      type: datum.type,
    }));
  }

  if (!messageType) return result;
  return result.filter(
    (e) =>
      (e.type === messageType && containsType) ||
      (e.type !== messageType && !containsType)
  );
};

export const parseOrganizationContents = (data) => {
  if (!data) return [];

  // Handle plain object
  const apps = data[CONTENT_TYPE_APPLICATION];
  if (apps) {
    const appsArray = Array.isArray(apps) ? apps : Object.values(apps);
    return appsArray.map((datum) => parseApplication(datum));
  }

  return [];
};
